import React from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Typography,
    Button,
    Toolbar,
    FormControlLabel,
    Grid,
    InputLabel,
    RadioGroup,
    Radio,
    FormHelperText,
    Fade,
    CircularProgress,
    Checkbox
} from '@material-ui/core';
import CustomizedTable from 'mdoc/utils/table';
import { dictionary, getPermissions } from 'mdoc/admin/axios';
import { getBrowserInfo, dateFormat } from 'mdoc/utils';
import { contentAddUpload, contentAddUploadFile, contentUploadDelete, contentUploadFiles } from 'mdoc/admin/axios/content';
import Toast from 'mdoc/utils/toast';
import { MuiPickersUtilsProvider, DateTimePicker } from 'material-ui-pickers';
import DateFnsUtils from '@date-io/date-fns';
import zhCNLocale from 'date-fns/locale/zh-CN';
import jaLocale from 'date-fns/locale/ja';
import enLocale from 'date-fns/locale/en-US';
import { getLang, messageFormat } from 'mdoc/utils';
import { Clear } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Dialog from 'mdoc/utils/myDialog';


const localeMap = {
    1: jaLocale,
    2: zhCNLocale,
    3: enLocale,
};
const lang = getLang();
const styles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    buttons: {
        marginLeft: '-20px'
    },
    margin: {
        margin: theme.spacing.unit,
    },
    space: {
        height: theme.spacing.unit
    },
    bootstrapFormLabel: {
        lineHeight: '48px',
    },
    Radio: {
        padding: '0px 10px'
    },
    buttonProgress: {
        color: '#ff0000',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
        opacity: 0.5
    },
    fileInput: {
        display: 'none',
    }
});
class Content_Upload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedRowKeys: [], // Check here to configure the default column
            data: [],
            detailData: [],
            loading: false,
            permissions: getPermissions() || [],
            langIdData: [

            ],
            pagination: {
                pageNumber: 1,
                pageSize: 5,
                count: 0,
                sidx: '',
                sord: ''
            },
            dictWord: {
                'content_add': '',
                'file_select': '',
                'registration': '',
                'cancel': '',
                'book_title': '',
                'published_department': '',
                'published_user_name': '',
                'content_description': '',
                'book_open_state': '',
                'effective_start_date': '',
                'effective_end_date': '',
                'release_method': '',
                'page_methods': '',
                'side_special': '',
                'side_special_page_count': '',
                'management': '',
                'delete_record': '',
                'mixture': '',
                'download': '',
                'streaming': '',
                'left_methods': '',
                'right_methods': '',
                'invalid': '',
                'valid': '',
                '1screen_1page_show': '',
                '1screen_2page_show': '',
                'public': '',
                'non_public': '',
                'msg_error_not_select_file': '',
                'read_expires_period': '',
                'msg_error_endate_greater_than_start_date': '',
                msg_error_over_length: '',
                msg_error_upload_file_type_invalid: '',
                msg_confirm_really_delete: '',
                notice_title: '',
                msg_error_not_null_with_item: '',
                'push_notice': '',
                'mail_delivery': '',
                'content_update_notification': ''
            },
            formData: {
                applyId: {
                    value: ''
                },
                categoryId: {
                    value: ''
                },
                idStatus: {
                    width: '',
                    value: 0,
                },
                isOpen: {
                    value: 0,
                    error: false,
                    errorMsg: ''
                },
                effectiveStartDate: {
                    value: null,
                    error: false,
                    errorMsg: ''
                },
                effectiveEndDate: {
                    value: null,
                    error: false,
                    errorMsg: ''
                },
                downloadWay: {
                    value: 0,
                    error: false,
                    errorMsg: ''
                },
                flip: {
                    value: 0,
                    error: false,
                    errorMsg: ''
                },
                isHorizontal: {
                    value: 0,
                    error: false,
                    errorMsg: ''
                },
                horizontalPageCount: {
                    value: 1,
                    error: false,
                    errorMsg: ''
                },
                author: {
                    value: '',
                    error: false,
                    errorMsg: ''
                },
                publisher: {
                    value: '',
                    error: false,
                    errorMsg: ''
                },
                pushDelivery: {
                    value: false
                },
                mailDelivery: {
                    value: false
                }
            },
            pdfUpLoading: false,
            dialogCheckedDelete: false,
            okLoading: false,
            deleteItem: {}
        }
    }

    componentWillMount() {
        let dict = {};
        dictionary(this.state.dictWord).then(res => {
            for (let key in res) {
                let val = res[key];
                dict[val.dictKey] = val.dictValue;
            }
            this.setState({
                dictWord: dict,

            })
        });

        if (!this.props.match.params.id) {
            this.props.history.replace('/admin/content/contentread');
            return;
        }
        contentUploadFiles(this.props.match.params.id).then(res => {
            let cond = res.docTblApply;
            let formData = this.state.formData;
            formData['applyId'] = Object.assign(this.state['formData']['applyId'], { value: cond.id });
            formData['isOpen'] = Object.assign(this.state['formData']['isOpen'], { value: cond.isOpen });
            formData['downloadWay'] = Object.assign(this.state['formData']['downloadWay'], { value: cond.downloadWay });
            formData['flip'] = Object.assign(this.state['formData']['flip'], { value: cond.flip });
            formData['isHorizontal'] = Object.assign(this.state['formData']['isHorizontal'], { value: cond.isHorizontal });
            formData['horizontalPageCount'] = Object.assign(this.state['formData']['horizontalPageCount'], { value: cond.horizontalPageCount });
            formData['author'] = Object.assign(this.state['formData']['author'], { value: cond.author });
            formData['publisher'] = Object.assign(this.state['formData']['publisher'], { value: cond.publisher });
            formData['effectiveStartDate'] = Object.assign(this.state['formData']['effectiveStartDate'], { value: cond.effectiveStartDate ? cond.effectiveStartDate : null });
            formData['effectiveEndDate'] = Object.assign(this.state['formData']['effectiveEndDate'], { value: cond.effectiveEndDate ? cond.effectiveEndDate : null });
            if (cond.categoryDepth5Id) {
                formData['categoryId'] = Object.assign(this.state['formData']['categoryId'], { value: cond.categoryDepth5Id });
            } else if (cond.categoryDepth4Id) {
                formData['categoryId'] = Object.assign(this.state['formData']['categoryId'], { value: cond.categoryDepth4Id });
            } else if (cond.categoryDepth3Id) {
                formData['categoryId'] = Object.assign(this.state['formData']['categoryId'], { value: cond.categoryDepth3Id });
            } else if (cond.categoryDepth2Id) {
                formData['categoryId'] = Object.assign(this.state['formData']['categoryId'], { value: cond.categoryDepth2Id });
            } else {
                formData['categoryId'] = Object.assign(this.state['formData']['categoryId'], { value: cond.categoryDepth1Id });
            }
            this.setState({
                formData,
                data: res.docWkBookList
            })
        });
    }

    handleChange = (filed) => event => {
        let formData = this.state.formData;
        if (filed === 'effectiveStartDate' || filed === 'effectiveEndDate') {
            let value = event;
            formData[filed] = Object.assign(this.state['formData'][filed], { value: value });
        } else if (filed === 'mailDelivery' || filed === 'pushDelivery') {
            let value = event.target.checked;
            formData[filed] = Object.assign(this.state['formData'][filed], { value: value });
        } else {
            let value = event.target.value;
            formData[filed] = Object.assign(this.state['formData'][filed], { value: value });
        }
        this.setState({
            formData
        });
    };

    onCellUpdate(index, newData, oldData, res) {
        new Promise((resolve, reject) => {
            if (res.error) {
                Toast.error(res.errorMessage);
            }
            let data = this.state.data;
            newData['errorMessage'] = res.errorMessage;
            data[index] = newData;
            this.setState({ data }, () => resolve());

        })
    }

    onMultipleDrop(event) {
        let files = event.target.files || [];
        if (files.length < 1) return;
        let data = this.state.data;
        let fileNames = [];
        for (let key in data) {
            let value = data[key];
            fileNames.push(value.title);
        }
        let res = true;
        let browserInfo = getBrowserInfo();
        for (let index in files) {
            let item = files[index];
            if (typeof item !== 'object') continue;
            const name = item['name'];
            const lastIndex = name.lastIndexOf('.');
            let title = name.substring(0, lastIndex);
            let type = name.substr(lastIndex).toLowerCase();
            if (['.pdf', '.mp4', '.epub'].indexOf(type) < 0) {
                res = false;
                break;
            }
            if (fileNames.indexOf(title) < 0) {
                data.push({
                    applyId: '',
                    categoryId: '',
                    title: title,
                    fileName: name,
                    introduction: '',
                    isOpen: 0,
                    downloadWay: 0,
                    flip: 0,
                    isHorizontal: 0,
                    horizontalPageCount: 1,
                    createIp: browserInfo[2],
                    author: '',
                    publisher: '',
                    fileType: type,
                    file: item,
                    id: '',
                    effectiveStartDate: null,
                    effectiveEndDate: null
                });
            }
        }
        if (!res) {
            Toast.error(this.state.dictWord['msg_error_upload_file_type_invalid']);
            return;
        }
        this.setState({
            data
        })
    }
    mulFileButton() {
        let fileInput = document.getElementById('mulButton-file');
        fileInput.value = [];
    }
    deleteFile(dataVal) {
        this.setState({
            deleteItem: dataVal,
            dialogCheckedDelete: true
        });
    }
    dialogHandleClose() {
        this.setState({
            deleteItem: {},
            dialogCheckedDelete: false
        });
    }
    dialogHandleOK() {
        let data = this.state.data;
        const index = data.indexOf(this.state.deleteItem);
        let item = data[index];
        if (item['fileUuid'] !== undefined) {
            contentUploadDelete(item.id).then(res => {
                data.splice(index, 1);
                this.setState({
                    data,
                    dialogCheckedDelete: false
                });
            })
        } else {
            data.splice(index, 1);
            this.setState({
                data,
                dialogCheckedDelete: false
            });
        }
    }
    register() {
        let me = this;
        var StartDate = new Date(Date.parse(this.state.formData.effectiveStartDate.value));
        var EndDate = new Date(Date.parse(this.state.formData.effectiveEndDate.value));
        let formData = this.state.formData;
        if (EndDate && StartDate) {
            if (StartDate > EndDate) {
                formData['effectiveEndDate'] = Object.assign(this.state['formData']['effectiveEndDate'], {
                    error: true,
                    errorMsg: this.state.dictWord.msg_error_endate_greater_than_start_date
                });
                this.setState({
                    formData
                })
                return;
            } else {
                formData['effectiveEndDate'] = Object.assign(this.state['formData']['effectiveEndDate'], {
                    error: false,
                    errorMsg: ''
                });
                this.setState({
                    formData,

                })
            }
        }
        let multipleList = [];
        let docWkBookList = this.state.data;
        let noticeType = '';
        let confirmData = this.state.formData;
        if (confirmData.isOpen.value === '1') {
            noticeType = 0
        } else {
            if (confirmData['pushDelivery']['value'] && confirmData['mailDelivery']['value']) {
                noticeType = 3
            } else if (confirmData['pushDelivery']['value'] && !confirmData['mailDelivery']['value']) {
                noticeType = 1
            } else if (!confirmData['pushDelivery']['value'] && confirmData['mailDelivery']['value']) {
                noticeType = 2
            } else {
                noticeType = 0
            }
        }
        let res = '';
        for (let i = 0; i < docWkBookList.length; i++) {
            let value = docWkBookList[i];
            if (value['errorMessage'] && value['errorMessage'].length > 0) {
                res = value['errorMessage'];
            }
            docWkBookList[i].applyId = this.state.formData.applyId.value;
            docWkBookList[i].isOpen = this.state.formData.isOpen.value;
            docWkBookList[i].downloadWay = this.state.formData.downloadWay.value;
            docWkBookList[i].flip = docWkBookList[i].fileType === 'video/mp4' ? 0 : this.state.formData.flip.value;
            docWkBookList[i].isHorizontal = docWkBookList[i].fileType === 'video/mp4' ? 0 : this.state.formData.isHorizontal.value;
            docWkBookList[i].horizontalPageCount = docWkBookList[i].fileType === 'video/mp4' ? 0 : this.state.formData.isHorizontal.value.toString() === '0' ? 1 : this.state.formData.horizontalPageCount.value;
            docWkBookList[i].categoryId = this.state.formData.categoryId.value;
            docWkBookList[i].effectiveStartDate = this.state.formData.effectiveStartDate.value ? dateFormat(new Date(this.state.formData.effectiveStartDate.value), 'yyyy-MM-ddThh:mm:ss') : '';
            docWkBookList[i].effectiveEndDate = this.state.formData.effectiveEndDate.value ? dateFormat(new Date(this.state.formData.effectiveEndDate.value), 'yyyy-MM-ddThh:mm:ss') : '';
            docWkBookList[i].author = this.state.formData.author.value;
            docWkBookList[i].publisher = this.state.formData.publisher.value;
            docWkBookList[i].noticeType = noticeType;
            if (docWkBookList[i].file) {
                multipleList.push(docWkBookList[i].file);
            }
        }
        if (res.length > 0) {
            Toast.error(res);
            return;
        }
        let data = new FormData();
        if (multipleList.length > 0) {
            for (let key in multipleList) {
                let item = multipleList[key];
                data.append("upfile", item);
            }
            this.setState({
                pdfUpLoading: true
            })
            contentAddUpload(this.state.formData.applyId.value, data).then(res => {
                me.setState({
                    pdfUpLoading: false
                });
                if (!res.error) {
                    contentAddUploadFile({
                        docTblApply: {
                            downloadWay: this.state.formData.downloadWay.value,
                            flip: this.state.formData.flip.value,
                            horizontalPageCount: this.state.formData.isHorizontal.value.toString() === '0' ? 1 : this.state.formData.horizontalPageCount.value,
                            id: this.state.formData.applyId.value,
                            isHorizontal: this.state.formData.isHorizontal.value,
                            isOpen: this.state.formData.isOpen.value,
                            effectiveStartDate: this.state.formData.effectiveStartDate.value,
                            effectiveEndDate: this.state.formData.effectiveEndDate.value,
                            noticeType: noticeType
                        },
                        docWkBookList: docWkBookList
                    }).then(result => {
                        this.props.history.push('/admin/content/contentread');
                    }).catch(function (err) {
                        Toast.error(err);
                    })
                } else {
                    Toast.error(res.errorMessage);
                }
            }).catch(function (err) {
                me.setState({
                    pdfUpLoading: false
                });
                Toast.error(err);
            })
        } else {
            contentAddUploadFile({
                docTblApply: {
                    downloadWay: this.state.formData.downloadWay.value,
                    flip: this.state.formData.flip.value,
                    horizontalPageCount: this.state.formData.isHorizontal.value.toString() === '0' ? 1 : this.state.formData.horizontalPageCount.value,
                    id: this.state.formData.applyId.value,
                    isHorizontal: this.state.formData.isHorizontal.value,
                    isOpen: this.state.formData.isOpen.value,
                    effectiveStartDate: this.state.formData.effectiveStartDate.value,
                    effectiveEndDate: this.state.formData.effectiveEndDate.value,
                    noticeType: noticeType
                },
                docWkBookList: docWkBookList
            }).then(result => {
                me.setState({
                    pdfUpLoading: false
                })
                this.props.history.push('/admin/content/contentread');
            }).catch(function (err) {
                me.setState({
                    pdfUpLoading: false
                })
                Toast.error(err);
            })
        }
    }

    //Cleaning time input box 
    clearStartTime = () => {
        let formData = this.state.formData;
        formData['effectiveStartDate'] = Object.assign(this.state['formData']['effectiveStartDate'], { value: null });
        this.setState({
            formData: formData
        });
    }
    clearEndTime = () => {
        let formData = this.state.formData;
        formData['effectiveEndDate'] = Object.assign(this.state['formData']['effectiveEndDate'], { value: null });
        this.setState({
            formData: formData
        });
    }
    render() {
        const { classes } = this.props;
        const { dictWord, formData, permissions } = this.state;
        const columns = [
            {
                title: this.state.dictWord.book_title,
                dataIndex: 'title',
                width: '320px',
                type: 'text',
                validate: {
                    maxlength: {
                        value: 250,
                        errorMsg: this.state.dictWord.msg_error_over_length
                    },
                    required: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.notice_title)
                }

            },
            {
                title: this.state.dictWord.content_description,
                dataIndex: 'introduction',
                width: '380px',
                type: 'text',
                validate: {
                    maxlength: {
                        value: 500,
                        errorMsg: this.state.dictWord.msg_error_over_length
                    },
                },

            },
            {
                title: this.state.dictWord.management,
                dataIndex: 'averageScore4',
                width: '140px',
                toolTipDisabled: true,
                render: (text, record) => {
                    return <IconButton aria-label="Delete" onClick={this.deleteFile.bind(this, record)}>
                        <DeleteIcon />
                    </IconButton>;

                }

            },
        ];
        return (
            <div className="mainDom">
                <div className={classes.appBarSpacer} />
                <Grid container direction="row" justify="space-between" alignItems="center" >
                    <Grid item xs={12} md={12}>
                        <Button variant="contained" color="primary" className={classes.margin} onClick={this.register.bind(this)} disabled={this.state.pdfUpLoading}>
                            {this.state.dictWord.registration}
                            <Fade
                                in={this.state.pdfUpLoading}
                                style={{
                                    transitionDelay: this.state.pdfUpLoading ? '800ms' : '0ms',
                                }}
                                unmountOnExit
                            >
                                <CircularProgress size={24} className={classes.buttonProgress} />
                            </Fade>
                        </Button>
                        <Button href={'/admin.html#/admin/content/contentread'} className={classes.margin} variant="contained" color="primary">
                            {this.state.dictWord.cancel}
                        </Button>
                    </Grid>
                </Grid>
                <div className={classes.space} />
                <Grid container className={classes.margin}>
                    <Grid container className={classes.margin}>
                        <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                            <InputLabel shrink htmlFor="isOpen">
                                {dictWord.book_open_state}
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <RadioGroup
                                aria-label="isOpen"
                                name="isOpen"
                                value={formData.isOpen.value.toString()}
                                onChange={this.handleChange('isOpen')}
                                row
                            >
                                <FormControlLabel
                                    value="0"
                                    control={<Radio className={classes.Radio} color="primary" />}
                                    label={dictWord.public}
                                    labelPlacement="end"
                                    classes={{
                                        label: classes.label
                                    }}
                                />
                                <FormControlLabel
                                    value="1"
                                    control={<Radio className={classes.Radio} color="primary" />}
                                    label={dictWord.non_public}
                                    labelPlacement="end"
                                    classes={{
                                        label: classes.label
                                    }}
                                />
                            </RadioGroup>
                        </Grid>
                    </Grid>
                    <Grid container className={classes.margin}>
                        <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                            <InputLabel shrink htmlFor="readExpiresPeriod">
                                {dictWord.read_expires_period}
                            </InputLabel>
                        </Grid>

                        <Grid item xs={12} md={2}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[lang]}>
                                <div className="picker">
                                    <DateTimePicker ampm={false} format="yyyy/MM/dd HH:mm" value={formData.effectiveStartDate.value} onChange={this.handleChange('effectiveStartDate')} />
                                    <Clear
                                        color="disabled"
                                        style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                                        onClick={this.clearStartTime}
                                    />
                                </div>

                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={2} md={1} style={{ maxWidth: '44px', marginLeft: '0px', marginRight: '0px', display: 'inlineBlock', lineHeight: '34px', textAlign: 'center' }}> <span>~</span> </Grid>
                        <Grid item xs={12} md={2}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[lang]}>
                                <div className="picker">
                                    <DateTimePicker ampm={false} format="yyyy/MM/dd HH:mm" value={formData.effectiveEndDate.value} onChange={this.handleChange('effectiveEndDate')} />
                                    <Clear
                                        color="disabled"
                                        style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                                        onClick={this.clearEndTime}
                                    />
                                </div>
                            </MuiPickersUtilsProvider>
                            {formData.effectiveEndDate.error ? <FormHelperText id="effectiveEndDate-error-text" error={formData.effectiveEndDate.error}>{formData.effectiveEndDate.errorMsg}</FormHelperText> : ''}
                        </Grid>
                    </Grid>
                    <Grid container className={classes.margin}>
                        <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                            <InputLabel shrink htmlFor="downloadWay">
                                {dictWord.release_method}
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <RadioGroup
                                aria-label="downloadWay"
                                name="downloadWay"
                                value={formData.downloadWay.value.toString()}
                                onChange={this.handleChange('downloadWay')}
                                row
                            >
                                <FormControlLabel
                                    value="0"
                                    control={<Radio className={classes.Radio} color="primary" />}
                                    label={dictWord.mixture}
                                    labelPlacement="end"
                                    classes={{
                                        label: classes.label
                                    }}
                                />
                                <FormControlLabel
                                    value="1"
                                    control={<Radio className={classes.Radio} color="primary" />}
                                    label={dictWord.download}
                                    labelPlacement="end"
                                    classes={{
                                        label: classes.label
                                    }}
                                />
                                <FormControlLabel
                                    value="2"
                                    control={<Radio className={classes.Radio} color="primary" />}
                                    label={dictWord.streaming}
                                    labelPlacement="end"
                                    classes={{
                                        label: classes.label
                                    }}
                                />
                            </RadioGroup>
                        </Grid>
                    </Grid>
                    <Grid container className={classes.margin}>
                        <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                            <InputLabel shrink htmlFor="flip">
                                {dictWord.page_methods}
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <RadioGroup
                                aria-label="flip"
                                name="flip"
                                value={formData.flip.value.toString()}
                                onChange={this.handleChange('flip')}
                                row
                            >
                                <FormControlLabel
                                    value="0"
                                    control={<Radio className={classes.Radio} color="primary" />}
                                    label={dictWord.left_methods}
                                    labelPlacement="end"
                                    classes={{
                                        label: classes.label
                                    }}
                                />
                                <FormControlLabel
                                    value="1"
                                    control={<Radio className={classes.Radio} color="primary" />}
                                    label={dictWord.right_methods}
                                    labelPlacement="end"
                                    classes={{
                                        label: classes.label
                                    }}
                                />
                            </RadioGroup>
                        </Grid>
                    </Grid>

                    <Grid container className={classes.margin}>
                        <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                            <InputLabel shrink htmlFor="isHorizontal">
                                {dictWord.side_special}
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <RadioGroup
                                aria-label="isHorizontal"
                                name="isHorizontal"
                                value={formData.isHorizontal.value.toString()}
                                onChange={this.handleChange('isHorizontal')}
                                row
                            >
                                <FormControlLabel
                                    value="0"
                                    control={<Radio className={classes.Radio} color="primary" />}
                                    label={dictWord.invalid}
                                    labelPlacement="end"
                                    classes={{
                                        label: classes.label
                                    }}
                                />
                                <FormControlLabel
                                    value="1"
                                    control={<Radio className={classes.Radio} color="primary" />}
                                    label={dictWord.valid}
                                    labelPlacement="end"
                                    classes={{
                                        label: classes.label
                                    }}
                                />
                            </RadioGroup>
                        </Grid>
                    </Grid>
                    <Grid container className={classes.margin}>
                        <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                            <InputLabel shrink htmlFor="bootstrap-input">
                                {dictWord.side_special_page_count}
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <RadioGroup
                                aria-label="horizontalPageCount"
                                name="horizontalPageCount"
                                value={formData.isHorizontal.value.toString() === '1' ? formData.horizontalPageCount.value.toString() : ""}
                                onChange={this.handleChange('horizontalPageCount')}
                                row
                            >
                                <FormControlLabel
                                    value="1"
                                    control={<Radio color="primary" />}
                                    label={dictWord['1screen_1page_show']}
                                    labelPlacement="end"
                                    disabled={formData.isHorizontal.value.toString() === '1' ? false : true}
                                    classes={{
                                        label: classes.label
                                    }}
                                />
                                <FormControlLabel
                                    value="0"
                                    control={<Radio className={classes.Radio} color="primary" />}
                                    label={dictWord['1screen_2page_show']}
                                    labelPlacement="end"
                                    disabled={formData.isHorizontal.value.toString() === '1' ? false : true}
                                    classes={{
                                        label: classes.label
                                    }}
                                />
                            </RadioGroup>
                        </Grid>
                    </Grid>
                    {permissions.includes(27) || permissions.includes(28) ?
                        <Grid container className={classes.margin}>
                            <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                                <InputLabel shrink htmlFor="contentUpdateNotification">
                                    {dictWord.content_update_notification}
                                </InputLabel>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                {permissions.includes(28) ?
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                className={classes.Checkbox}
                                                checked={formData.pushDelivery.value}
                                                onChange={this.handleChange('pushDelivery')}
                                                disabled={formData.isOpen.value === '1' ? true : false}
                                            />
                                        }
                                        label={this.state.dictWord.push_notice}
                                    /> : null}
                                {permissions.includes(27) ?
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                className={classes.Checkbox}
                                                checked={formData.mailDelivery.value}
                                                onChange={this.handleChange('mailDelivery')}
                                                disabled={formData.isOpen.value === '1' ? true : false}
                                            />
                                        }
                                        label={this.state.dictWord.mail_delivery}
                                    />
                                    : null}
                            </Grid>
                        </Grid> : null}
                </Grid>
                <div className={classes.space} />
                <Toolbar className={classes.margin}>
                    <input
                        accept=".pdf,.epub,.mp4"
                        className={classes.fileInput}
                        id="mulButton-file"
                        type="file"
                        multiple
                        onChange={this.onMultipleDrop.bind(this)}
                    />
                    <label htmlFor="mulButton-file">
                        <Button variant="contained" component="span" color="primary" className={classes.buttons} onClick={this.mulFileButton.bind(this)}>
                            {dictWord.file_select}
                        </Button>
                    </label>
                </Toolbar>
                <Typography component="div" className={classes.margin}>
                    <CustomizedTable
                        data={this.state.data}
                        columns={columns}
                        count={this.state.pagination.count}
                        noPage
                        editable={{
                            onCellUpdate: this.onCellUpdate.bind(this)
                        }}
                    />
                </Typography>
                <Dialog
                    open={this.state.dialogCheckedDelete}
                    option={{
                        ok: {
                            text: this.state.dictWord['yes'],
                        },
                        close: {
                            text: this.state.dictWord['cancel'],
                        },
                    }}
                    content={<p>{dictWord.msg_confirm_really_delete}</p>}
                    okLoading={this.state.okLoading}
                    handleOk={this.dialogHandleOK.bind(this)}
                    handleClose={this.dialogHandleClose.bind(this)}
                />
            </div>
        );
    }
}

Content_Upload.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(Content_Upload);